import { getOrderForId, getCurrentUser } from '../selectors';
import { generateOrderId } from '../utils/order';
import { getTranslateByScope } from '../i18n';
import { orderStatus } from '../constants';

export const translate = getTranslateByScope('app.actions.orders');

/* eslint-disable no-unused-vars */
export const copyOrder = ({ id, context, onCopy }) => {
  const orderToBeCopied = getOrderForId(context)(id);
  if (!orderToBeCopied) return;

  const { _id, _rev, ...orderData } = orderToBeCopied.doc;
  const user = getCurrentUser(context);

  context.actions.createOrder({
    ...orderData,
    id: generateOrderId(user.AgentNo__c),
    status: orderStatus.unsynced,
  });

  context.actions.setToast({
    title: translate('copyOrder.success'),
  });

  onCopy('copy');
};
